import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyInfo } from '../models/currency-info';

@Pipe({ name: 'currMultiplier' })
export class CurrencyMultiplierPipe implements PipeTransform {
    transform(value: number, currency: CurrencyInfo): number {
        return value * currency.Multiplier;
    }
}
